import { Chip } from '@mui/material'
import { kycv2PersonStatusColors } from '../../kycv2.enums'

export const PersonStatusBadge = ({ status }) => {
  if (!status) return <span>---</span>

  const colors = kycv2PersonStatusColors[status] || { bg: '#9e9e9e', color: '#ffffff' }

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: colors.bg,
        color: colors.color,
        fontWeight: 500,
        fontSize: '0.75rem',
      }}
    />
  )
}
